<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="medium-panel" @click.stop>
                <div class="dialog-title" v-t="'message.title_csv_import_export'"></div>
                <hr class="dialog-hr">
                <div class="dialog-body" style="overflow-y: auto">
                    <div v-text="selectedDictionaryInfo.name" style="font-size:larger;font-weight: 500;padding-top:27px; padding-bottom:27px;"></div>

                    <!-- 言語の選択 -->
                    <!-- NOTE: Make enable el-select when multilingual supported. -->
                    <div style="font-size: small; padding-bottom: 12px">
                        <span v-t="'message.title_stt_extension_csv_dictionary_language'"></span>
                    </div>
                    <div>
                        <el-select v-model="selectedLanguageIndex" style="width:130px;padding-bottom: 27px">
                            <div v-if="$i18n.locale === 'ja'">
                                <el-option style="font-size:12px" v-for="language in languageList" :key="language.value" :label="language.description" :value="language.value"></el-option>
                            </div>
                            <div v-else>
                                <el-option style="font-size:12px" v-for="language in languageList" :key="language.value" :label="language.description_en" :value="language.value"></el-option>
                            </div>
                        </el-select>
                    </div>

                    <!-- 現在の内容をエクスポート -->
                    <div class="import-step-title" v-t= "'message.title_stt_extension_csv_dictionary_export'"></div>
                    <div class="import-step-context">
                        <button class="downloadButton" @click="doCsvExportDictionary">
                            <img src="@/assets/icon_download.svg" class="button-icon"/><span v-t="'message.button_export'"></span>
                        </button>
                    </div>

                    <!-- インポートするCSVファイルを選択 -->
                    <div class="import-step-title" v-t= "'message.title_stt_extension_csv_dictionary_import'"></div>
                    <div class="import-step-context">
                        <div style="color: #d55169;padding-bottom: 10px; font-size: small" v-html="$t('message.hint_stt_extension_dictionary_csv_import_caution')"></div>
                        <label for="file_upload">
                            <img src="@/assets/icon_attach.svg" class="button-icon"/><span v-t="'message.action_selection'"/>
                            <input id="file_upload" @change="selectedFile" type="file" name="file" style="display:none"/>
                        </label>
                        <span v-if="showUploadInfo">
                            <span v-if="uploadFile != null" class='selected-filename'>{{ uploadFile.name}}</span>
                        </span>
                    </div>
                    <div class="import-step-context">
                        <el-button class="dialog-ok-button" @click="doCsvImportDictionary(uploadFile)" :disabled="disableImport" v-t="'message.button_import'"></el-button>
                    </div>
                    <div class="import-step-context" v-if="showDownloadErrorLogButton">
                        <button class="downloadErrorLogButton" @click="doCsvDownloadErrorLog">
                            <img src="@/assets/icon_download_white.svg" class="button-icon"/><span v-t="'message.button_download_error_log'"></span>
                        </button>
                    </div>

                    <!-- 注 -->
                    <div class="comment">
                        <div class="import-step-description" v-html="$t('message.hint_stt_extension_dictionary_csv_note')"></div>
                    </div>
                </div>

                <!-- ボタン -->
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_close'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import server from "@/components/ServerApi.js";
import commonUtil from '@/components/commonutil.js';
import constants from '@/components/constants.js';

export default {
    props: {
        selectedDictionaryInfo : {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            languageList: [],
            selectedLanguageIndex: 0,
            disableImport: true,
            showUploadInfo: true,
            showDownloadErrorLogButton: false,
            errorLogBlob: null,
        };
    },

    created: function() {
        this.languageList = commonUtil.getLanguageIndexList(this.$i18n.locale);
        // NOTE: Currently, Japanese is only supported.
        this.selectedLanguageIndex = 1;
    },

    methods: {
        selectedFile: function(e) {
            e.preventDefault();
            this.uploadFile = e.target.files[0];
            this.disableImport = false;
            this.reDrawUploadInfo();
        },

        releaseSelectedFile: function() {
          this.uploadFile = null;
          document.getElementById("file_upload").value = ""; // これをしないと、同じファイルを選択したときに、「入力値の変化」と見なさなれずchangeイベントが発火しない。
          this.disableImport = true;
          this.reDrawUploadInfo();
        },

        reDrawUploadInfo() {
            this.showUploadInfo = false;
            this.$nextTick(() => {
                 this.showUploadInfo = true
            })
        },

        doCsvExportDictionary() {
            let self = this;
            server.post("/csvexportsttdictionary", {dictionaryId: this.selectedDictionaryInfo.id, languageIndex: this.selectedLanguageIndex, locale: this.$i18n.locale})
                .then((res) => {
                    if( typeof res.data.status === 'undefined') {
                        const universalBOM = "\uFEFF";
                        const blob = new Blob([universalBOM + res.data], { type: 'application/csv;charset=UTF-8' })
                        let languageDescription = this.getSelectedLanguageDescription();
                        commonUtil.downloadFile(blob, "buddycom_stt_dictionary_" + this.selectedDictionaryInfo.name + "_" + languageDescription + ".csv")
                    } else {
                        switch(res.data.status) {
                            case constants.STATUS_ERROR_INVALID_PARAMETER:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_stt_extension_dictionary_invalid_params"));
                                break;
                            case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_stt_extension_dictionary_already_changed"));
                                break;
                            default:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","doCsvExportDictionary").replace("{code}",res.data.status));
                                break;
                        }
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "doCsvExportDictionary", error);
                });
        },

        doCsvImportDictionary(uploadFile, callback) {
            let json = JSON.stringify({dictionaryId: this.selectedDictionaryInfo.id, languageIndex: this.selectedLanguageIndex, locale: this.$i18n.locale});
            let self = this;
            let loadingScreen = this.loadingScreenWith('processing ...');
            server.postWithFile("/csvimportsttdictionary", uploadFile, json)
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_import_complete").replace("{resultCount}",res.data.resultCount));
                            break;
                        case constants.STATUS_ERROR_PERMISSION_DENIED:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"info_needs_tenant_admin_privilege"));
                            break;
                        case constants.STATUS_ERROR_INVALID_PARAMETER:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_stt_extension_dictionary_invalid_params"));
                            break;
                        case constants.STATUS_ERROR_EXCEEDS_MAX_SIZE:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_upload_file_too_big_custom").replace("{maxSize}", "3MB"));
                            break;
                        case constants.STATUS_ERROR_INVALID_CSV_FORMAT:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_stt_extension_dictionary_csv_no_invalid_format"));
                            break;
                        case constants.STATUS_ERROR_EXCEEDS_MAX_COUNT:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_stt_extension_dictionary_phrase_exceeds_max_count").replace("{maxPhraseCountPerLang}",res.data.maxPhraseCountPerLang));
                            break;
                        case constants.STATUS_ERROR_NO_CONTENTS:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_stt_extension_dictionary_csv_no_contents"));
                            break;
                        case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_stt_extension_dictionary_already_changed"));
                            break;
                        case constants.STATUS_ERROR_DUPLICATED:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_stt_extension_dictionary_phrase_duplicated"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","doCsvImportDictionary").replace("{code}",res.data.status));
                            break;
                    }

                    // change error log download button state.
                    switch (res.data.status) {
                        case constants.STATUS_ERROR_INVALID_CSV_FORMAT:
                            const universalBOM = "\uFEFF";
                            this.errorLogBlob = new Blob([universalBOM + res.data.errorLog], { type: 'application/csv;charset=UTF-8' });
                            this.showDownloadErrorLogButton = true;
                            break;
                        default:
                            this.showDownloadErrorLogButton = false;
                            break;
                    }
                })
                .catch(function(error) {
                    commonUtil.putExceptionErrorMessage(self, "doCsvImportDictionary", error);
                })
                .finally(() => {
                    self.releaseSelectedFile();
                    loadingScreen.close();
                });
        },

        doCsvDownloadErrorLog() {
            let languageDescription = this.getSelectedLanguageDescription();
            commonUtil.downloadFile(this.errorLogBlob, "error_log_import_" + this.selectedDictionaryInfo.name + "_" + languageDescription + ".csv");
        },

        getSelectedLanguageDescription() {
            let language = this.languageList.find(l => l.value === this.selectedLanguageIndex);
            return this.$i18n.locale === 'ja' ? language.description : language.description_en;
        },

        loadingScreenWith(text) {
            return this.$loading({
                lock: true ,
                text: text,
                spinner: 'el-icon-loading' ,
                background: 'rgba(0, 0, 0, 0)'
            });
        },
    }
}
</script>

<style scoped>
.medium-panel {
    background: #fff;
    position: absolute;
    padding: 0;
    left: 50%;
    top: 50%;
    width: 600px;
    height: 64vh;
    margin-left: -300px;
    margin-top: -32vh;
    transition: all .3s ease;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
}

.dialog-body {
    font-size: 14px;
    padding-right: 25px;
    padding-left: 25px;
}

.import-step-title {
    padding-top: 15px;
    padding-bottom: 12px;
    font-size: 12px;
    font-weight: bold;
}

.import-step-context {
    padding-right: 15px;
    padding-left: 15px;
    padding-bottom: 10px;
}

.import-step-description {
    padding-bottom: 3px;
}

label {
    font-size: 14px;
    color: #333B48;
    background-color: #f6f6f6;
    padding: 6px;
    border-radius: 4px;
    border: solid 1px;
    line-height: 33px;
    border-color: #dcdfe6;
    cursor: pointer;
}

.button-icon {
    height: 18px;
    vertical-align: middle;
    margin-right: 4px;
}

.downloadButton {
    line-height: 33px;
    font-size: 14px;
    color: #333B48;
    background-color: #f6f6f6;
    border-radius: 4px;
    border: solid 1px;
    width: 150px;
    border-color: #dcdfe6;
    text-align: center;
    cursor: pointer;
    display: inline-block;
    padding: 0;
    outline: 0;
}

.downloadErrorLogButton {
    line-height: 33px;
    font-size: 14px;
    color: #ffffff;
    background-color: #ff1e1eed;
    border-radius: 4px;
    border: solid 1px;
    width: 230px;
    border-color: #ff1e1eed;
    text-align: center;
    cursor: pointer;
    display: inline-block;
    padding: 0;
    outline: 0;
}

.selected-filename {
    padding-left: 10px;
}

.comment {
    padding-top:30px;
    padding-bottom: 15px;
}
</style>
